<h2 mat-dialog-title *ngIf="!(data.headerTranslationKey === '')">{{ data.headerTranslationKey | translate }}</h2>
<mat-dialog-content>
  <p>
    <reviews-source-selection-panel
      *ngIf="reviewSources$ | async as leaveReviewSources"
      (sourceIdsSelected)="requestSourceIdsSelected($event)"
      [reviewSources]="leaveReviewSources"
      [maxSelections]="data.maxSelections"
      [keepOpen]="true"
      [headerTranslationKey]="'REVIEWS.WIDGET_CONFIG.SOURCES.REQUEST_REVIEWS_ON'"
      [openWithSelectedSources$]="preselectedIDs$"
    ></reviews-source-selection-panel>
  </p>
</mat-dialog-content>
